import { format } from "date-fns"
import { DateTime } from "luxon"

export const formatTimeFRstring = (dateString: string) => {
  if (!dateString) return ""
  return new Date(dateString).toLocaleTimeString("fr")
}
export const formatDateFRstring = (dateString: string) => {
  if (!dateString) return "Aucune"
  return new Date(dateString).toLocaleDateString("fr")
}

export const formatDateDate = (dateString: Date) => {
  return new Date(dateString).toLocaleDateString()
}

export const formatDateFRdate = (dateString: Date) => {
  if (!dateString) return "Aucune"
  return new Date(dateString).toLocaleDateString("fr")
}

export function formatDateNumbering(
  numberingDateFormat: string,
  dateString: Date
): string {
  if (!numberingDateFormat) {
    return ""
  }
  const englishFormat = numberingDateFormat
    .replace(/A/g, "y")
    .replace(/J/g, "d")

  return format(dateString, englishFormat)
}

export function formatDateFrWithSeconds(dateString: string) {
  const date = new Date(dateString)
  const datePattern = new Intl.DateTimeFormat("fr", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
  return datePattern.format(date)
}

export function getDueDate({
  billDate,
  paymentPeriod,
}: {
  billDate: string
  paymentPeriod: number
}) {
  return DateTime.fromFormat(billDate, "yyyy-MM-dd")
    .plus({
      day: paymentPeriod,
    })
    .toFormat("yyyy-MM-dd")
}

